import React from "react";
import { Card, CardContent, CardHeader, Divider, Grid, Typography } from '@material-ui/core';
import {
  EntityHasSystemsCard,
  EntityLayout,
  AboutField,
  RelatedEntitiesCard,
} from '@backstage/plugin-catalog';
import { EaPackDomainEntityV1beta1 } from '@internal/plugin-ea-pack-common';
import { MarkdownContent } from '@backstage/core-components';
import { EntityRefLinks, EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import { Entity, parseEntityRef } from '@backstage/catalog-model';
import { TableColumn } from '@backstage/core-components';
import { UserAndTitleField } from "../UserCard";
import { FunctionalDomainValueStreamsAndBusinessCapabilitiesCard } from "../EnterpriseLayerEntityLayout/ValueStreamsAndBusinessCapabilitiesTab";

const enterpriseLayerColumns: TableColumn<EaPackDomainEntityV1beta1>[] = [
  EntityTable.columns.createEntityRefColumn({ defaultKind: "Domain" }),
  { title: "Category", field: "spec.category" },
  { title: "Order", field: "spec.orderInLayer", render: row => row.spec.orderInLayer ?? "-" },
];

const asDomainEntities = (entities: Entity[]): EaPackDomainEntityV1beta1[] => entities as EaPackDomainEntityV1beta1[];

export const FunctionalDomainEntityLayout = (props: { children?: React.ReactNode, gemcheckCard?: React.ReactNode }) => {
  const entity = useEntity().entity as EaPackDomainEntityV1beta1;
  const roles = entity.spec.roles;

  return (
    <EntityLayout parentEntityRelations={["partOf"]}>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <Card>
              <CardHeader title="About" />
              <Divider />
              <CardContent>
                <Grid container>
                  <Grid item xs={12}>
                    <AboutField label="Description">
                      <MarkdownContent content={entity?.metadata?.description || 'No description'} />
                    </AboutField>
                  </Grid>
                  <Grid item xs={6}>
                    <AboutField label="Enterprise Layer">
                      {entity.spec.subdomainOf
                      ? (
                        <EntityRefLinks
                          entityRefs={[parseEntityRef(entity.spec.subdomainOf, { defaultKind: "domain" })]}
                          defaultKind="domain"
                        />
                      )
                      : <Typography>Not set</Typography>
                    }
                    </AboutField>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Card>
                  <CardHeader title="The Team" />
                  <Divider />
                  <CardContent>
                    <Grid container>
                      <UserAndTitleField user={roles?.domainLead} title="Domain Lead" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.enterpriseArchitect} title="Enterprise Architect" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12}>
                {props.gemcheckCard}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <FunctionalDomainValueStreamsAndBusinessCapabilitiesCard />
          </Grid>
          <Grid item md={12}>
            <EntityHasSystemsCard variant="gridItem" title="Products" />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      {props.children}
    </EntityLayout>
  );
};
